// General
export const SWISH_ID_TAG = '{{swishID}}';
export const EDIT = 'Redigera';
export const OK = 'Ok';
export const CANCEL = 'Avbryt';
export const ENABLED = 'Publicerad';
export const DISABLED = 'Ej publicerad';
export const CURRENCY = 'SEK';
export const HLF_LINK_TEXT = 'Gå till hjart-lungfonden.se';
export const LOGIN = 'Logga in';
export const LOGOUT = 'Logga ut';
export const SEARCH = 'Sök';

// File Uploader
export const IMAGE_SIZE_RECOMMENDATIONS =
  'Rekommenderad bildstorlek: 960 x 480 pixlar (liggande format)';
export const IMAGE_ALLOWED_TYPES = 'Godkända filtyper: jpeg, jpg, png';
export const IMAGE_MAX_SIZE = 'Maxstorlek: 2mb';
export const IMAGE_DRAG_AND_DROP = 'Dra och släpp filen här';
export const IMAGE_OR = 'eller';
export const IMAGE_SELECT = 'Välj en fil';
export const IMAGE_CANCEL = 'Avbryt';
export const IMAGE_SAVE = 'Spara';
export const IMAGE_PREVIEW = 'Förhandsgranskning';
export const IMAGE_ZOOM_IN = 'Zooma in';
export const IMAGE_ZOOM_OUT = 'Zooma ut';
export const IMAGE_CHANGE = 'Byt bild';
export const IMAGE_CROP = 'Beskär bild';
export const IMAGE_CURRENT = 'Nuvarande bild';
export const IMAGE_UPLOADER_PREVIEW = 'preview';
export const IMAGE_UPLOADER_CROP = 'crop';
export const IMAGE_UPLOADER_ADD = 'add';

// Account information
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const LOADING = 'LOADING';
export const INFORMATION_SAVED = 'Dina uppgifter har sparats!';
export const AN_ERROR_OCCURRED = 'Ett fel inträffade';
export const MY_INFORMATION = 'Mina uppgifter';
export const PROFILE = 'Profil';

// Auth0
export const AUTH_0_LOGIN = 'login';
export const AUTH_0_SIGN_UP = 'signup';

// Forms
export const FUNDRAISER_START_DATE = 'Startdatum*';
export const FUNDRAISER_END_DATE = 'Slutdatum (ej obligatoriskt)';
export const FUNDRAISER_CURRENT = 'Löpande';
export const FUNRAISER_DISABLE = 'Avpublicera insamling';
export const FUNDRAISER_ENABLE = 'Aktivera insamling';
export const FUNDRAISER_HELP_TEXT_PRE =
  'Är du säker på att du vill avpublicera insamlingen';
export const FUNDRAISER_HELP_TEXT_END =
  'Insamlingen kommer att döljas i sök och objektlistning.';
export const FUNDRAISER_ACCEPT_CONTENT_RESPONSIBILITY_LABEL = 'Jag intygar*';
export const FUNDRAISER_ACCEPT_CONTENT_RESPONSIBILITY_TEXT =
  'Härmed intygar jag att jag har tagit del av informationen samt att samtliga personer godkänt publiceringen och att vårdnadshavares samtycke inhämtats vid publicering av barns uppgifter.';
export const DONATION_NEWSLETTER_LABEL =
  'Jag vill ha Hjärt-Lungfondens nyhetsbrev där jag får forskningsbaserade livsstilstips och de senaste forskningsnyheterna om hjärt- och lungsjukdomar.';

// Cookies
export const HLF_SESSION = 'hlf_session';
export const HLF_IDENTITY = 'hlf_identity';

//Api
export const POSE_AS_API_ACCESS_USER = 'nei';
export const TYPE_EGEN_INSAMLING_PAYMENT = 'Betalning egen insamling';
export const STATUS_SUCCESS = 'success';
export const STATUS_APPROVED = 'approved';

export const DRAFT_DATE_NEW_FUNDRAISER = '1904-01-01';
